import design_01 from "./design_01";
import design_02 from "./design_02";
import design_03 from "./design_03";
import design_04 from "./design_04";

export default [{
    template: design_01,
    id: 'welcome'
}, {
    template: design_02,
    id: 'happy_halloween'
}, {
    template: design_03,
    id: 'product_announcement'
}, {
    template: design_04,
    id: 'event_invitation'
}];